import { render } from "./SmallTasksPage.vue?vue&type=template&id=8613a30a"
import script from "./SmallTasksPage.vue?vue&type=script&lang=js"
export * from "./SmallTasksPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__